<header>
  <div class="container-fluid d-flex justify-content-between bd-highlight">
    <div class="p-2 bd-highlight">
      <div class="d-flex flex-row">
        <div>
          <img src="assets/images/gov-modify.png" />
        </div>
        <div>
          <a href="#">
            <img src="assets/images/Group 98.png" style="margin-left: 20px" />
          </a>
        </div>
      </div>
    </div>
    <div class="header-content text-wrap hide-at-mobile">
      National Skills Development Authority (NSDA), Prime Minister’s Office,
      Bangladesh
    </div>

    <div>
      <!-- <img
        src="assets/images/1200px-Mujib_100_Logo.svg.png"
        style="width: 90px"
      /> -->
    </div>
  </div>

  <div class="header-content text-wrap show-at-mobile">
    National Skills Development Authority (NSDA), Prime Minister’s Office,
    Bangladesh
  </div>

  <div class="mobile-menu">
    <img
      (click)="toggleMobileMenu()"
      src="assets/images/burger-menu.svg"
      alt="Menu"
    />
  </div>

  <nav class="navbar navbar-expand-md navbar-dark bg-dark menu-bar">
    <div class="container-fluid">
      <ng-container *ngIf="visible">
        <div class="navbar-collapse d-flex justify-content-between"
          id="navbarCollapse"
        >
          <ul class="navbar-nav me-auto mb-2 mb-md-0">
            <!-- <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Home</a>
          </li> -->
          </ul>

          <div class="d-flex">
            <!-- <nz-dropdown-menu #certificatemenu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li nz-menu-item>
                <a
                  class="nav-link active"
                  aria-current="page"
                  (click)="tciCertificate()"
                  >List</a
                >
              </li>
            </ul>
          </nz-dropdown-menu> -->

            <!-- <a
          nz-dropdown
          class="mt-2"
          style="color: green"
          [nzDropdownMenu]="assessCertificate"
        >
           Assessment Certificate
          <i nz-icon nzType="down"></i>
        </a> -->

            <nz-dropdown-menu #assessCertificate="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <li nz-menu-item>
                  <a
                    class="nav-link active"
                    aria-current="page"
                    (click)="downloadCertificate()"
                    >Download</a
                  >
                </li>
              </ul>
            </nz-dropdown-menu>

            <marquee width="54%" direction="left" style="margin-top:10px">
              <span style="color:red">জাতীয় দক্ষতা উন্নয়ন কর্তৃপক্ষ এর সকল সেবার জন্য যোগাযোগের হটলাইন নাম্বার - 01969906565 (সকাল ৯টা হতে বিকাল ৫টা পর্যন্ত, সরকারি ছুটির দিন ব্যতীত)</span>
            </marquee>

            <a
              nz-dropdown
              class="mt-2"
              style="margin: 10px; color: green"
              [nzDropdownMenu]="menu"
              [hidden]="isProfileHidden"
            >
              Profile
              <i nz-icon nzType="down"></i>
            </a>

            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <li nz-menu-item>
                  <a
                    class="nav-link active"
                    aria-current="page"
                    (click)="onLogout()"
                    >Logout</a
                  >
                </li>

                <li
                  nz-menu-item
                  *ngIf="
                    userInfo?.roles[0].name === 'User' ||
                    userInfo?.roles[0].name === 'STP_Master'
                  "
                >
                  <a
                    class="nav-link active"
                    aria-current="page"
                    routerLink="/home/stp-registration/dash-board"
                    >Dashboard</a
                  >
                </li>
                <li nz-menu-item *ngIf="userInfo?.roles[0].name === 'Tam_User'">
                  <a
                    class="nav-link active"
                    aria-current="page"
                    routerLink="/home/training-and-assessment-materials/tam-list"
                    >Dashboard</a
                  >
                </li>
                <li
                  nz-menu-item
                  *ngIf="userInfo?.roles[0].name === 'Applicant'"
                >
                  <a
                    class="nav-link active"
                    aria-current="page"
                    routerLink="/home"
                    >Dashboard</a
                  >
                </li>
                <li nz-menu-item *ngIf="userInfo?.roles[0].name === 'Admin'">
                  <a
                    class="nav-link active"
                    aria-current="page"
                    routerLink="/home/stp-registration/stp-applications"
                    >Dashboard</a
                  >
                </li>
                <li nz-menu-item *ngIf="userInfo?.roles[0].name === 'Assessor'">
                  <a
                    class="nav-link active"
                    aria-current="page"
                    routerLink="/home"
                    >Dashboard</a
                  >
                </li>
                <li nz-menu-item *ngIf="userInfo?.roles[0].name === 'ISC'">
                  <a
                    class="nav-link active"
                    aria-current="page"
                    routerLink="/home"
                    >Dashboard</a
                  >
                </li>
                <li nz-menu-item *ngIf="napUserInfo?.userId > 0">
                  <a
                    class="nav-link active"
                    aria-current="page"
                    routerLink="/NAP-home"
                    >Dashboard</a
                  >
                </li>
              </ul>
            </nz-dropdown-menu>

            <ul class="navbar-nav me-auto mb-md-0">
              <li class="nav-item">
                <a
                  class="nav-link btn btn-outline-custom"
                  (click)="tciCertificate()"
                >
                  National Skills Certificates
                </a>
              </li>

              <li class="nav-item" [hidden]="isLoginHidden">
                <a
                  class="nav-link active btn btn-outline-custom"
                  aria-current="page"
                  routerLink="/login"
                  >Login</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link btn btn-outline-custom"
                  nz-dropdown
                  [nzDropdownMenu]="helping"
                  >User Manual  <i nz-icon nzType="down"></i>
                </a>
                <nz-dropdown-menu #helping="nzDropdownMenu">
                  <ul nz-menu nzSelectable>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Password_Recovery_or_Update_User_Manual.pdf"
                        >Password Recovery or Update</a
                      >
                    </li>
                    <!-- <li nz-menu-item>
                  <a
                    class="nav-link active"
                    aria-current="page"
                    target="_blank"
                    href="/assets/file/user_manual/Individual_RPL_Batch_Assessment.pdf">Assessment Application (RPL Individual Batch)</a>
                </li> -->
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Assessment_Application_Regular_Batch_User_Manual.pdf"
                        >Assessment Application (Regular Batch)</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Bangla_User_Manual_of_Certificate_Correction_V1.0.pdf"
                        >Certificate Correction</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Bangla_User_Manual_of_Payment_Reconciliation_V1.0.pdf"
                        >Payment Reconciliation</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/STP_Registration_User_Manual.pdf"
                        >STP Registration</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Course_and_Assessment_Center_Accreditation_User_Manual.pdf"
                        >Course and Assessment Center Accreditation</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Training_Management_And_GraduateTracking_User_Manual.pdf"
                        >STP Training Management</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Graduate_Tracking_User_Manual.pdf"
                        >Graduate Tracking User Manual</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/National_Action_Plan_Monitoring_User_Manual.pdf"
                        >National Action Plan Monitoring</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Assessor_Enlistment_User_Manual.pdf"
                        >Assessor User Manual</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/Assessors_Result_Upload_User_Manual_Bangla.pdf"
                        >Assessor Result Upload</a
                      >
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/user_manual/NHRDF_Financing_User_Manual.pdf"
                        >NHRDF Financing User Manual</a
                      >
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link btn btn-outline-custom"
                  nz-dropdown
                  [nzDropdownMenu]="contact"
                  >Contact <i nz-icon nzType="down"></i>
                </a>
                <nz-dropdown-menu #contact="nzDropdownMenu">
                  <ul nz-menu nzSelectable>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        target="_blank"
                        href="/assets/file/Help_Desk.pdf"
                        >Help Desk
                      </a>
                    </li>
                    <li nz-menu-item>
                      <a
                        class="nav-link active"
                        aria-current="page"
                        href="https://support.skillsportal.gov.bd/open.php"
                        target="_blank"
                        >Technical Support
                      </a>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link btn btn-outline-custom"
                  href="http://www.nsda.gov.bd/"
                  >Visit to NSDA</a
                >
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
    </div>
  </nav>
</header>
